import { Integration } from '../data/integrations';

interface IntegrationCardProps {
  integration: Integration;
  size?: 'default' | 'large';
}

export default function IntegrationCard({ integration, size = 'default' }: IntegrationCardProps) {
  const isLarge = size === 'large';

  return (
    <div
      className={`group relative bg-white rounded-xl border-2 border-gray-200 hover:border-[#66b3ff] hover:shadow-xl transition-all duration-300 ${
        isLarge ? 'p-8' : 'p-6'
      }`}
    >
      {/* Status Badges */}
      <div className="absolute top-3 right-3 flex gap-2">
        {integration.status === 'coming-soon' && (
          <span className="px-2 py-1 bg-[#b3d9ff]/20 text-[#22577A] text-xs font-semibold rounded-full">
            Coming Soon
          </span>
        )}
        {integration.aiEnhanced && (
          <span className="px-2 py-1 bg-gradient-to-r from-[#66b3ff] to-[#b3d9ff] text-white text-xs font-semibold rounded-full flex items-center gap-1">
            <i className="ri-ai-generate text-xs"></i>
            AI Enhanced
          </span>
        )}
      </div>

      {/* Logo */}
      <div
        className={`${
          isLarge ? 'w-20 h-20 mb-6' : 'w-16 h-16 mb-4'
        } rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}
        style={{
          backgroundColor: integration.color
            ? `${integration.color}15`
            : '#e4f4ff20',
        }}
      >
        <i
          className={`${integration.logo} ${isLarge ? 'text-4xl' : 'text-3xl'}`}
          style={{ color: integration.color || '#22577A' }}
        ></i>
      </div>

      {/* Content */}
      <div>
        <h3
          className={`${
            isLarge ? 'text-2xl' : 'text-lg'
          } font-bold text-[#22577A] mb-2 group-hover:text-[#38a3a5] transition-colors`}
        >
          {integration.name}
        </h3>
        <p className={`${isLarge ? 'text-base' : 'text-sm'} text-gray-600 leading-relaxed`}>
          {integration.description}
        </p>
      </div>

      {/* Hover Effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#e4f4ff]/0 to-[#b3d9ff]/0 group-hover:from-[#e4f4ff]/5 group-hover:to-[#b3d9ff]/5 rounded-xl transition-all duration-300 pointer-events-none"></div>
    </div>
  );
}
